<template>
    <div class="tool-panel">
        <div>
            <ul>
                <li v-for= "item in toolList">
                    <div class="tool-list">
                        <a target="_blank" :href="item.url">
                            <img :src="toolImg(item)" alt="dynamic">
                            <span>{{item.name}}</span>
                        </a>
                    </div>
                </li>          
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name : "ToolPanel",
        data () {
            return {
                toolList:[
                    {
                        name : '标杆的神器',
                        url : 'http://www.h3c.com/cn/Service/Software_Download/Other_Product/H3C_Software/BG/BG/',
                        imgUrl :  "biaogan.png"     
                    },{
                        name : '根叔的云图',
                        url :　'http://www.h3c.com/cn/About_H3C/New_Media_Marketing/Root_uncle_cloud/',
                        imgUrl :  'genshu.png'
                    },{
                        name : 'H3C模拟器',
                        url :　'http://www.h3c.com/cn/Service/Document_Software/Software_Download/Other_Product/H3C_Cloud_Lab/Catalog/HCL/',
                        imgUrl :  'moniqi.png'  
                    },{
                        name : '知了社区',
                        url :　'https://zhiliao.h3c.com',
                        imgUrl : 'zhiliao.png'
                    }
                ]
            }
        },
        methods : {
            toolImg : function(item){
                return require("../../assets/img/"+item.imgUrl);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/panel/ToolPanel.vue